import { ICourse, ICourse2 } from '@et/types/Courses'
import DefaultTheme from '@styles/themes/defaultTheme'
import { PAYMENT_TYPES_THEME } from '@et/types/Enums'
import { deepPurple, neonPink } from '@styles/themes/darkThemeBeautifulLettering'
// TODO: reg price link and sale price link so we only have to change one item
const slug = 'beautiful-lettering'
const title = 'Beautiful Lettering in Procreate'
const course: ICourse2 = {
  theme: PAYMENT_TYPES_THEME.LIGHT,
  title,
  slug,
  videoId: `a2n4jjyj41`,
  keywords: [
    'beautiful lettering in procreate', 'ipad lettering', 'procreate', 'procreate tutorial', 'hand lettering', 'lettering', 'procreate lettering', 'procreate for beginners', 'procreate lettering tutorial', 'procreate app', 'ipad lettering procreate', 'iPad Pro', 'ipad lettering for beginners', 'calligraphy', 'lettering in procreate', 'how to hand letter', 'procreate brushes', 'procreate tips', 'ipad pro lettering', 'ipad lettering tutorial', 'procreate tutorial lettering'
  ],
  price: '147',
  salePrice: '127',
  paymentPlan:{
    price: '55',
    perMonth: '3 Payments of $55/m',
    savings: '10%'
  },
  motionMail: `https://s.mmgo.io/t/CKN6/scale_2x`,
  onSale: false,
  tagline: 'The ultimate guide to modern script lettering in Procreate',
  classDescriptor: 'The ultimate guide to modern script lettering in Procreate',
  intro: {
    imgName: 'procreate301/tablet-intro.png',
    imgAlt: 'Create custom modern lettering styles that are unique to you',
    bullets: [
      {
        title: 'Beginner Friendly',
        desc:
          'Step-by-step narration with closeups on all the details, so you feel confident in the process from start to finish.',
      },
      {
        title: 'A Versatile Process',
        desc:
          'Since every lettering style is different, this process has been fine-tuned to fit any situation. You’ll be able to achieve a realistic watercolor effect when you apply it to any style - hand lettered or typed.',
      },
      {
        title: 'Blend Options',
        desc:
          'You may want an ombré, one color, smooth transitions blend with one of your pieces and a multi-colored blend with water pockets on another. This course serves up 5 different blend options, so you’ll have plenty to choose from when you begin your next lettering piece.',
      },
      {
        title: 'Florals + Foliage Integration',
        desc:
          'Take your watercolor lettering even further by integrating florals and foliage! A bonus florals foundations module is included, so even if you’ve never painted florals before, you’ll be able to follow along and complete every project in the class.',
      },
    ],
  },
  projects: {
    beginner: [
      {
        title: 'Project 1',
        backgroundColor: `#7fb5e4`,
        textColor: `#4a5457`,
        subheadColor: `#fff`,
        projectImg: `procreate301/project-1.jpg`,
        projectImgMobile: `procreate301/project-1.jpg`,
        type: 'flat style',
        desc:
          'We perfect bounce lettering in Project one with an assignment to add bounce to any 3 spices you’d like.',
      },
      {
        title: 'Project 2',
        backgroundColor: `#006c24`,
        textColor: `#d5e4d9`,
        subheadColor: `#fcb900`,
        projectImg: `procreate301/project-2.jpg`,
        projectImgMobile: `procreate301/project-2-mobile.jpg`,
        type: 'flat style',
        desc:
          'Shifting weights is one of the most impactful ways to add style through breaking traditional lettering rules. In this assignment, you’ll hand letter the name of any color at least two different ways using different (custom) shifting weight rules to influence its style.',
      },
      {
        title: 'Project 3',
        backgroundColor: `#719b81`,
        textColor: `#313428`,
        subheadColor: `#f3ecdf`,
        projectImg: `procreate301/project-3.jpg`,
        projectImgMobile: `procreate301/project-3-mobile.jpg`,
        type: 'flat style',
        desc: 'By adding simple embellishments, a message can be enhanced substantially; no illustration background required! In this assignment, we take any two word chore and enhance its meaning by applying custom embellishments that are relevant to the message being communicated.',
      },
      {
        title: 'Project 4',
        type: 'chunky style',
        projectImg: `procreate501/project-4.jpg`,
        projectImgMobile: `procreate301/project-4-mobile.jpg`,
        backgroundColor: `#dee5dd`,
        textColor: `#565857`,
        subheadColor: `#c56b00`,
        desc:
          'When you establish hierarchy in a lettering composition, it’s important to emphasize your most meaningful words. In this assignment, we choose a line from a recipe, break down the hierarchy, then letter it out, altering style and adding what we’ve learned in the class to this point to deliver a beautiful layout.',
      },
      {
        title: 'Project 5',
        type: 'chunky style',
        projectImg: `procreate301/project-5.jpg`,
        projectImgMobile: `procreate301/project-5-mobile.jpg`,
        backgroundColor: `#ffd5bc`,
        textColor: `#613e2d`,
        subheadColor: `#419187`,
        desc:
          'Flourishing can take any word to a more beautiful and dynamic place. In this assignment, we incorporate what we covered in the flourishing guidelines and practice lessons and we turn an ugly word beautiful using only flourishing essentials.',
      },
      {
        title: 'Project 6',
        type: 'chunky style',
        projectImg: `procreate301/project-6.jpg`,
        projectImgMobile: `procreate301/project-6-mobile.jpg`,
        backgroundColor: `#11230e`,
        textColor: `#9cae94`,
        subheadColor: `#be8d87`,
        desc:
          'Style informs feeling. In the Lettering with Emotions lessons, we talked about how to choose and implement the right style choices to convey the feeling you want to associate with your lettering. For this project’s assignment, we take a two word phrase and we give it different meaning by only changing the lettering style.',
      },
      {
        title: 'Project 7',
        type: 'smooth style',
        projectImg: `procreate301/project-7.jpg`,
        projectImgMobile: `procreate301/project-7-mobile.jpg`,
        backgroundColor: `#67985d`,
        textColor: `#f3f0eb`,
        subheadColor: `#f4d547`,
        desc:
          'Mixing styles in a lettering layout can create visual breaks, focus and emphasis to make a message more impactful. In this project, we take a 3-7 word headline from a favorite website and bring it to life by mixing lettering styles strategically and adding in other style methods taught throughout the course.',
      },
      {
        title: 'Project 8',
        type: 'smooth style',
        projectImg: `procreate301/project-8.jpg`,
        projectImgMobile: `procreate301/project-8-mobile.jpg`,
        backgroundColor: `#11230e`,
        textColor: `#9cae94`,
        subheadColor: `#be8d87`,
        desc:
          'We bring everything together from what we learned in the course in this final lettering layout project. Taking a 5+ word lyric, quote or phrase, we transform the message with purposeful style methods from the course for an unique and meaningful composition.',
      },
    ],
    advanced: [],
  },
  curriculum: [
    {
      title: 'Getting Started',
      videos: [
        {
          title: 'Class Overview',
          duration: '6:42',
        },
        {
          title: 'Bonuses Location + Install Instructions',
          duration: '4:16',
        },
        {
          title: 'How to Use the Beautiful Lettering Brushes',
          duration: '6:32',
        },
        {
          title: 'How to Use the Lettering Guides Brushes',
          duration: '6:14',
        },
        {
          title: 'DO THIS BEFORE STARTING THE CLASS! DON\'T SKIP!',
          duration: '2:19',
        },
      ],
    },
    {
      title: 'Lettering Foundations: Understanding the Rules',
      videos: [
        {
          title: 'Rhythm Exercise',
          duration: '9:04',
        },
        {
          title: 'Core Strokes',
          duration: '10:16',
        },
        {
          title: 'Simple Script Practice',
          duration: '10:27',
        },
        {
          title: 'Different ways to practice',
          duration: '3:11',
        }
      ],
    },
    {
      title: 'Breaking the Rules + Adding Personality',
      videos: [
        {
          title: 'Bounce Lettering Basics',
          duration: '13:20',
        },
        {
          title: 'Bounce Lettering Practice: Part 1',
          duration: '11:55',
        },
        {
          title: 'Bounce Lettering Practice: Part 2',
          duration: '8:36',
        },
        {
          title: 'Bounce Lettering: Project 1',
          duration: '10:47',
        },
        {
          title: 'Shifting Weights',
          duration: '5:21',
        },
        {
          title: 'Shifting Weights: Project 2',
          duration: '5:56',
        },
        {
          title: 'Adding Embellishments: Part 1',
          duration: '13:29',
        },
        {
          title: 'Adding Embellishments: Part 2',
          duration: '10:12',
        },
        {
          title: 'Adding Embellishments: Project 3',
          duration: '3:20',
        },
        {
          title: 'Emphasis with Style',
          duration: '6:36',
        },
        {
          title: 'Emphasis with Style: Project 4, Part 1',
          duration: '9:47',
        },
        {
          title: 'Emphasis with Style: Project 4, Part 2',
          duration: '6:36',
        },
      ],
    },
    {
      title: 'BONUS: Flourishing Essentials',
      videos: [
        {
          title: 'Basic Flourishing Guidelines',
          duration: '9:49',
        },
        {
          title: 'Flourishing Practice: Part 1',
          duration: '6:11',
        },
        {
          title: 'Flourishing Practice: Part 2',
          duration: '15:22',
        },
        {
          title: 'Flourishing Essentials: Project 5',
          duration: '4:59',
        },
      ],
    },
    {
      title: 'Establishing Your Style',
      videos: [
        {
          title: 'Imitate Exercise: Part 1',
          duration: '12:08',
        },
        {
          title: 'Imitate Exercise: Part 2',
          duration: '11:19',
        },
        {
          title: 'Emotion Basics',
          duration: '9:06',
        },
        {
          title: 'Emotion Practice',
          duration: '4:26',
        },
        {
          title: 'Emotion: Project 6',
          duration: '2:57',
        },
        {
          title: 'Mixing Styles',
          duration: '7:20',
        },
        {
          title: 'Mixing Styles: Project 7',
          duration: '11:11',
        },
        {
          title: 'Lettering Layout/Final Project: Project 8, Part 1',
          duration: '13:34',
        },
        {
          title: 'Lettering Layout/Final Project: Project 8, Part 2',
          duration: '13:34',
        },
      ],
    },
    {
      title: 'Finishing Up',
      videos: [
        {
          title: 'Bonus: The Making of 4 Lettering Compositions',
          duration: '15:18',
        },
        {
          title: 'Bonus: Exporting Artwork',
          duration: '3:31',
        },
        {
          title: 'DO THIS LAST! DON\'T SKIP!',
          duration: '1:54',
        },
        {
          title: 'Next Steps + Thank You',
          duration: '2:29',
        },
      ],
    },
  ],
  bonuses: {
    headerImgName: `procreate301/bonus-title.png`,
    imgAlt: 'Watercolor lettering in Procreate Bonuses',
    gridType: 2,
    items: [
      {
        title: 'Beautiful Lettering Brush Set',
        desc: 'The full Procreate brush set (24 brushes!) are included with your enrollment, so you can follow along exactly. 12 unique style brushes with a practice version and pro version make up this set; use the practice versions to perfect your thicks and thins with color dynamics and the pro when you’re ready to level up.',
        imgName: 'beautiful-lettering/bonuses-1.jpg',
      },
      {
        title: 'Extended License of Beautiful Lettering Brushes',
        desc: '<p>An extended license of the brush set <span class="bold bonusPriceSpan">($30 value)</span> is included, so you can create unlimited artwork now and in the future with full permissions to sell it.</p>',
        imgName: 'beautiful-lettering/bonuses-2.jpg',
      },
      {
        title: 'Lettering Guides Brush Set',
        desc: '<p>Paint in guides and oblique lines quickly with this set of 10 guide brushes <span class="bold bonusPriceSpan">($10 value)</span>! Set includes 7 different guides providing you the flexibility to add exaggeration to your letterforms where you want it most. 3 oblique pattern brushes are also included: vertical, subtle italic and italic, so you can paint them on top of any preferred guide.</p>',
        imgName: 'beautiful-lettering/bonuses-3.jpg',
      },
      {
        title: 'Lesson Cheat Sheets',
        desc: 'A cheat sheet of what was taught for each style-enhancing method is included, so you can have them handy, whenever you’re practicing or working on your next lettering project.',
        imgName: 'beautiful-lettering/bonuses-4.jpg',
      },
      {
        title: 'Core Stroke Practice Sheets',
        desc: 'Get the basic lettering forms down quickly with this practice sheet and learn how to integrate those strokes within all of your future lettering.',
        imgName: 'beautiful-lettering/bonuses-5.jpg',
      },
      {
        title: 'Simple Script Practice Sheets',
        desc: 'Learn standard script lettering with this set of Procreate-specific practice sheets! Includes uppercase, lowercase, numbers and simple phrases.',
        imgName: 'beautiful-lettering/bonuses-6.jpg',
      },
      {
        title: 'Tuesday Freestyle Lettering Practice Sheets',
        desc: '<p>A bonus set of free practice sheets <span class="bold bonusPriceSpan">($10 value)</span>. Once you have Simple Script perfected, practice your thicks and thins in a loose, freestyle modern script style with these practice sheets. Uppercase, lowercase, numbers and simple phrases are provided.</p>',
        imgName: 'beautiful-lettering/bonuses-7.jpg',
      },
      {
        title: '8 Project Cards',
        desc: 'A Procreate project card file is included for each course project with the assignment and example lettering options provided. Follow along using the card to create your own projects!',
        imgName: 'beautiful-lettering/bonuses-8.jpg',
      },
      {
        title: '3 Color Swatches',
        desc: '3 color swatch files are provided so you can follow along with each lesson and project exactly. These work perfectly with the practice style Beautiful Lettering brushes for vibrant/eye candy outcomes!',
        imgName: 'beautiful-lettering/bonuses-9.jpg',
      },
    ],
  },
  courseCard: {
    title: 'Beautiful Lettering in Procreate',
    backgroundImgName: ``,
    backgroundColor: '#65807c',
    cardImgName: `procreate301/watercolor-class-card-4.jpg`,
    desc: 'Create beautiful and realistic watercolor lettering in Procreate! Learn versatile blending options, several texturing options and final details to bring your digital watercolor artwork to life. Created with beginners in mind, every step is described in detail, with clear control close ups and repetition for easy learning. This project based course makes learning fun with 8 unique projects to up your social media game at the same time. Get a bonus dose of inspiration and artwork options with florals and foliage foundations, so you’ll be able to create the stunning digital watercolor lettering compositions you’ve always wanted.',
    bullets: [
      'Access to 33 HD step-by-step videos',
      'Every project’s color palette',
      '8 unique watercolor lettering projects',
      'Bonus Florals + Foliage Foundations module',
      'Complete Procreate Watercolor Lettering Brush Pack (8 custom brushes)',
      'Extended license of the Procreate Watercolor Lettering Brush Pack',
      '4 unique watercolor paper textures',
      'Every project’s fully layered original Procreate file',
      'Unlimited updates',
      'Lifetime access to the class',
    ],
    brush: {
      enabled: true,
      image: {
        pencil: `apple2-pencil.png`,
        shadow: `sell-card-pencil-reflection-light.png`,
      },
    },
    priceColor: `#20323f`,
    saleColor: neonPink,
    stats: {
      modules: `#cc836f`,
      videos: `#758384`,
      hours: `#a79e8d`,
    },
  },
  faqs: [
    {
      question: 'Do you offer any refunds or guarantees?',
      answer: '<p>Yep! If you finish the course and feel you haven’t learned anything new, email me within 14 days of purchase for a full refund.</p>',
    },
    {
      question: 'How long can I access the course for?',
      answer: '<p>Forever! As long as Every Tuesday exists, this course will be available to watch. Take it at whatever pace you’d like, watch whenever, wherever and as many times as you’d like.</p>',
    },
    {
      question: 'Is this a live or pre-recorded course?',
      answer: '<p>This course is entirely pre-recorded, so you can take it whenever it works best with your schedule.</p>',
    },
    {
      question: 'Does this class come with subtitles/closed captions?',
      answer: '<p>Yep! There are English subtitles available for all videos.</p>',
    },
    {
      question: 'I’m new to hand lettering, is this course meant for beginners?',
      answer: '<p>It is! You’ll want to spend more time practicing the foundations before moving onto breaking foundational rules, but everything is included that you need to know to get started.</p>',
    },
    {
      question: 'I’m new to Procreate, will I be able to follow along?',
      answer: '<p>You will! We use all basic Procreate tools within the course and everything is explained in detail as you go. If anything is ever unclear, refer to my <a class="bold" target="_blank" href="https://every-tuesday.com/5x">free Procreate for Beginners course</a> which includes every tool explanation in detail that is used throughout the course.</p>',
    },
    {
      question: 'Do I need to have an iPad to take this course?',
      answer: '<p>This course was fully recorded using the Procreate app on an iPad, so it’s recommended that you have a pressure sensitive iPad to follow along.</p>',
    },
    {
      question: 'Do I need any special Procreate brushes to create these projects?',
      answer: '<p>You can use any brushes you’d like, but all brushes shown in the course are provided with your enrollment.</p>',
    },
    {
      question: 'I noticed there’s a similar course offered on Skillshare. What’s the difference?',
      answer: '<p>The course on Skillshare is an intro version of this course that only includes the first 3 lessons. For a full comparison of the two versions, please view <a class="bold" target="_blank" href="https://every-tuesday.com/beautiful-comparison">this chart</a>.</p>',
    },
    {
      question: 'What will I need to take this class?',
      answer: '<p>You’ll need a pressure sensitive iPad (<a class="bold" target="_blank" href="https://every-tuesday.com/ipads">any of these will work</a>), a compatible pressure sensitive stylus (the Apple Pencil is recommended) and the Procreate app installed (version 5.1.8 or newer).</p>',
    },
  ],
  testimonials: [],
  letsDoThis: {
    imgName: 'procreate301/lets-do-this-2.jpg',
    altTag: 'Enroll in Beautiful lettering for Procreate today!',
    text: 'Welcome to Beautiful Lettering in Procreate, the ultimate guide to modern script lettering in Procreate',
  },
  sellCard: {
    priceColor: '#20323f',
    saleColor: neonPink,
    cardImg: '',
    saleLink: 'https://courses.every-tuesday.com/purchase?product_id=3526521',
    link: 'https://courses.every-tuesday.com/purchase?product_id=3526522',
    paymentPlanLink: 'https://courses.every-tuesday.com/purchase?product_id=3526526',
    customBtnBackgroundColor: '#20323f',
    h2Color: '#20323f',
    hoverColor: {
      h2: `#fff`,
      text: neonPink,
      overlay: `#20323f`,
      cardDescription: '#fff'
    },
    bullets: [
      'Instant access to all videos and bonuses',
      'Extended license + full Beautiful Lettering Procreate Brush Set',
      'Full Tuesday Lettering Guides Brush Set',
      'Simple Script lettering practice sheets',
      'Tuesday Freestyle lettering practice sheets',
      'Lesson cheat sheets',
      'Bonus: flourishing essentials module',
      'Bonus: 4 lettering layout tutorials',
      '14 day money back guarantee',
    ],
  },
}
export default course
